module.exports = __webpack_public_path__ + "img/рз_20.3ecadb06.png";